import { User } from '@labsavvyapp/components'
import { LAB_TYPE } from '../../../viewmodels'

export const generateLabType = (me: User) => {
  const labType = me?.partner?.config?.ordering?.default_lab_type || LAB_TYPE.options[1].value
  const labTypeInput = LAB_TYPE.options.find((option) => option.value === labType)

  return labTypeInput
}
